<template>
  <b-tab title="Posts" lazy>
    <div slot="title">
      <span class="font-size-md active">Posts</span>

      <div class="divider"></div>
    </div>

    <b-row v-if="active" align-h="between">
      <b-col sm="12" md="4">
        <post-list
          :posts="posts"
          :is-owner="isOwner"
          @clickPost="scrollToPost($event)"
          @click:verify="scrollToVerify"
        />
      </b-col>

      <!-- <b-col col sm="12" md="8" lg="6"> -->
      <b-col sm="12" md="8">
        <b-row v-if="editable">
          <b-col cols="12" class="text-right">
            <b-button
              ref="button__create-post"
              variant="first"
              :disabled="disabled"
              class="mb-3 button__create-new-post"
              :to="createPostPage"
              >Create new post</b-button
            >
          </b-col>
        </b-row>

        <b-row align-h="center">
          <b-col cols="12">
            <!-- Modal noti certificate when learner pass //learner only, first time only -->
            <modal-congratulation
              v-if="!isOwner && credential"
              :show="credential.seen_at === null ? true : false"
              :accredible-link="credential.accredible_credential.url"
              :credential-id="credential.id"
            />

            <!-- Certificate when learner pass //learner only -->
            <div class="d-flex justify-content-center">
              <post-certificate
                v-if="!isOwner && credential"
                :certificate-image-link="credential.accredible_credential.certificate.image.preview"
                :accredible-link="credential.accredible_credential.url"
              />
            </div>

            <div class="d-flex justify-content-center mb-5">
              <main-meeting-post
                v-if="learningUnit && section"
                :learning-unit="learningUnit"
                :section="section"
                class="card"
              />
            </div>

            <div class="container__posts">
              <base-card-post-schedule
                v-for="(post, index) in posts"
                :key="index"
                :ref="`post-${post.id}`"
                :post="post"
                :learning-unit="learningUnit"
                :is-show-mark-complete="isShowMarkComplete"
                :disabled="disabled"
                :is-private="post.meeting !== null && !post.is_published"
                :show-date="post.meeting === null || post.is_published"
                :is-show-video-player="post.meeting === null"
                :is-show-attachment="post.meeting === null"
                :is-owner="isOwner"
                :check-consent="post.meeting !== null && !isOwner"
                :post-schedule="getPostSchedule(post.id, section.id)"
                :section-id="section.id"
                :section="section"
                :editable="editable"
                class="mb-5"
                @post:deleted="onPostDeleted"
                @post:published="onPostPublished"
              >
                <!-- <template v-slot:alert="{ post }">
                  <post-conflict-alert
                    v-if="isOwner"
                    :show="
                      isOwner &&
                      post &&
                      isPostsConflict &&
                      isPostsConflict[post.id]
                    "
                    :section="section"
                    :post="post"
                    :conflict-type="conflictType[post.id]"
                  >
                  </post-conflict-alert>
                </template> -->

                <template v-slot:footer="{ post: postData = {} }">
                  <div
                    v-if="postData.is_submission"
                    class="card-body"
                    :class="`${isOwner ? 'container__review' : 'container__submission'}`"
                  >
                    <div class="header__title">
                      {{ isOwner ? 'Review' : 'Assessment' }}
                    </div>

                    <component
                      :is="submissionComponent"
                      v-bind="getSubmissionProps(postData.id, user.id)"
                      class="mt-3 mb-2"
                      @click="gotoSubmissionPage(postData.id)"
                    />
                  </div>
                </template>
              </base-card-post-schedule>

              <div v-if="!isOwner && isModeLearnVerify" class="d-flex justify-content-center">
                <div ref="card__verify-competency" class="card card-box-verify">
                  <div class="card-body px-0">
                    <div class="px-3">
                      <p class="text-black-50">Are you ready ?</p>
                      <h5><b>Your progress is almost complete!</b></h5>
                    </div>
                    <hr />
                    <div class="px-3">
                      <b-button variant="success" @click="goToVerify">Verify Competency</b-button>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="fetching" class="d-flex justify-content-center container__loadmore mb-4">
                <b-spinner label="Loading..." variant="dark" />
              </div>

              <!-- <div
                v-if="isOwner && isOBEM"
                class="card__post card card-box"
                @click="goToPageGrantCertificate"
              >
                <div class="card-body">
                  Learners will be approved after completing the Learning unit.
                </div>
                <div class="border-top p-4" style="border-width: 2px !important">
                  <b-button
                    class="button__evaluate-learning-result"
                    variant="success"
                  >
                    Evaluate Learning Result
                  </b-button>
                </div>
              </div> -->
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import { map } from 'lodash';
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';
import Post from '@/models/Post';
import Status from '@/models/Status';
import AssessmentStatus from '@/models/AssessmentStatus';
import User from '@/models/User';
import Credential from '@/models/Credential';
import PostSchedule from '@/models/PostSchedule';
import BaseCardPostSchedule from '@/components/base-components/BaseCardPostSchedule';
import PostList from './PostList';
import PostCertificate from './PostCertificate';
import ModalCongratulation from './ModalCongratulation';
import AssessmentSubmission from '@/views/Submission/components/AssessmentSubmission';
import ReviewSubmission from './ReviewSubmission';
// import PostConflictAlert from "@/components/Post/PostConflictAlert";
import MainMeetingPost from '@/components/Post/MainMeetingPost';
import Application from '@/models/Application';

export default {
  components: {
    BaseCardPostSchedule,
    PostList,
    PostCertificate,
    ModalCongratulation,
    reviewSubmission: ReviewSubmission,
    assessmentSubmission: AssessmentSubmission,
    // PostConflictAlert,
    MainMeetingPost
  },
  props: {
    user: {
      type: User,
      require: true,
      default: null
    },

    learners: {
      type: Array,
      default: () => []
    },

    learningUnit: {
      type: LearningUnit,
      required: true
    },

    section: {
      type: Section,
      required: true
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    },

    isOwner: {
      type: [Number, Boolean],
      default: false
    },

    active: {
      type: [Number, Boolean],
      default: false
    },

    editable: {
      type: [Number, Boolean],
      default: false
    }
  },

  data() {
    return {
      fetching: false,
      isPostsConflict: {},
      conflictType: {},
      postScheduleMapping: {},
      postScheduleIds: []
    };
  },

  computed: {
    isOBEM() {
      return this.learningUnit.isOBEM();
    },

    submissionComponent() {
      return this.isOwner ? 'reviewSubmission' : 'assessmentSubmission';
    },

    isShowMarkComplete() {
      return this.isOwner ? false : true;
    },

    posts() {
      const { postScheduleIds = [] } = this;

      const posts = postScheduleIds.map((postScheduleId) => {
        const postSchedule = PostSchedule.query().whereId(postScheduleId).first();

        const post = Post.query()
          .whereId(postSchedule.post_id)
          .with('additional_criterion')
          .with('vimeo')
          .with('assessment_statuses')
          .with('meeting.meeting_records.vimeo')
          .with('bunny_video')
          .first();

        return post;
      });

      return posts.filter(Boolean);
    },

    credential() {
      return (
        Credential.query()
          .where('learning_unit_id', this.learningUnit.id)
          .where('user_id', this.user.id)
          .first() || null
      );
    },

    createPostRoute() {
      return {
        name: 'design-planning/post/create',
        params: { sectionId: this.section.id },
        query: {
          previousPath: this.$route.fullPath
        }
      };
    },

    applied() {
      return (
        Application.query()
          .where((apply) => {
            return apply.user.id == this.user.id && apply.learning_unit.id == this.learningUnit.id;
          })
          .first() || null
      );
    },

    isModeLearnVerify() {
      return this.applied ? this.applied.isModeLearnVerify : false;
    },

    createPostPage() {
      return {
        name: 'design-planning/post/create',
        params: {
          learningUnitId: this.learningUnit.id,
          sectionId: this.section.id
        },
        query: {
          previousPath: this.$route.fullPath,
          view: 'feed'
        }
      };
    }
  },

  async mounted() {
    await this.init();

    if (!this.isOwner) {
      this.$_getSiteControlMixin_updateParams({
        mc_id: this.learningUnit.id,
        mc_name: this.learningUnit.name,
        mc_learning_progress: this.learningUnit.getLearningProgress(this.user.id)
      });
    }
  },

  methods: {
    getSubmissionProps(postId, userId) {
      if (this.isOwner) {
        const learnerIds = map(this.learners, 'id');

        return {
          'review-pending-submissions': AssessmentStatus.query()
            .where('post_id', postId)
            .where('status_id', Status.reviewPending ? Status.reviewPending.id : null)
            .where('user_id', (value) => {
              return learnerIds.includes(value);
            })
            .with('status')
            .all(),
          'is-owner': this.isOwner
        };
      } else {
        return {
          'assessment-submission-status': AssessmentStatus.query()
            .where('post_id', postId)
            .where('user_id', userId)
            .with('status')
            .first()
        };
      }
    },

    getPostSchedule(postId, sectionId) {
      const postScheduleId = this.postScheduleMapping[`${postId}_${sectionId}`];

      return PostSchedule.find(postScheduleId);
    },

    async onPostPublished() {
      await this.init();
    },

    onPostDeleted(postId) {
      const postScheduleKey = `${postId}_${this.section.id}`;

      const postScheduleId = this.postScheduleMapping[postScheduleKey];

      if (postScheduleId) {
        this.postScheduleIds = this.postScheduleIds.filter((id) => id !== postScheduleId);

        this.$delete(this.postScheduleMapping, postScheduleKey);
      }
    },

    async init() {
      this.fetching = true;

      await Promise.all([
        this.fetchCredential(),
        // this.fetchCheckConflict(),
        this.fetchPost()
      ]);

      this.fetching = false;
    },

    async fetchCredential() {
      let promise;

      try {
        promise = await Credential.api().fetch(this.learningUnit.id, this.user.id);
      } catch (error) {
        console.error(error);
        this.$toast.error('Cannot load credential');
      }

      return promise;
    },

    // async fetchCheckConflict() {
    //   let conflict;

    //   if (this.isOwner) {
    //     try {
    //       conflict = await LearningUnit.api().getConflictBetweenSectionAndPost(
    //         this.learningUnit.id
    //       );

    //       if (conflict && conflict[this.section.id]) {
    //         const { post, conflictType } = conflict[this.section.id];

    //         this.isPostsConflict = post;
    //         this.conflictType = conflictType;
    //       }
    //     } catch (error) {
    //       console.error(error);
    //       this.$toast.error("Cannot load conflicts");
    //     }
    //   }

    //   return conflict;
    // },

    async fetchPost() {
      let response;

      try {
        if (this.isOwner) {
          ({ response } = await PostSchedule.api().findForTeacher(this.section.id));
        } else {
          ({ response } = await PostSchedule.api().findForLearner(this.section.id));
        }

        if (response && response.data) {
          const postScheduleIds = response.data.map(({ id, post, section } = {}) => {
            this.$set(this.postScheduleMapping, `${post.id}_${section}`, id);

            return id;
          });

          this.postScheduleIds = [...postScheduleIds];
        }
      } catch (error) {
        console.error(error);
        this.isPageError = true;
        this.$toast.error('Cannot load posts');
      }

      return response;
    },

    scrollToPost(postId) {
      const [refPost] = this.$refs[`post-${postId}`];

      refPost.$el.scrollIntoView({
        behavior: 'smooth'
      });
    },

    scrollToVerify() {
      const ref = this.$refs[`card__verify-competency`];

      ref.scrollIntoView({
        behavior: 'smooth'
      });
    },

    goToVerify() {
      this.$router.push({
        name: 'learning-unit/method-components',
        params: {
          learningUnitId: this.learningUnit.id
        }
      });
    },

    gotoSubmissionPage(postId) {
      this.$router.push({
        name: this.isOwner ? 'TeachingReviewSubmission' : 'learnerResponseSubmission',
        params: {
          learningUnitId: this.learningUnit.id,
          sectionId: this.section.id,
          postId: postId
        },
        query: {
          ...this.$route.query
        }
      });
    }

    // goToPageGrantCertificate() {
    //   this.$router.push({
    //     name: 'learning-unit/grant-certificate/teacher',
    //     params: {
    //       learningUnitId: this.learningUnit.id,
    //       section: this.section.id
    //     },
    //     query: {
    //       ...this.$route.query
    //     }
    //   });
    // }
  }
};
</script>

<style lang="scss">
.card__online-meeting,
.card__post,
.card__certificate-wrapper {
  max-width: 100%;
}

@media (min-width: 768px) {
  .card__online-meeting,
  .card__post,
  .card__certificate-wrapper {
    max-width: 680px;
  }
}

.card-box-verify {
  border-width: 4px 0px 0px 0px;
  border-color: #1bc943;
  width: 100%;
  max-width: 680px;
}
</style>
